module.exports = __webpack_public_path__ + "static/media/wa-background-dark.cb32dcb2.png";